<template>
    <div>
        <div class="flex flex-col justify-center md:flex-row">
            <div class="text-3xl lg:text-6xl mr-2">
                EAF Viewer
            </div>
            <div class="text-lg lg:text-3xl md:mt-4 lg:mt-12">
                A tool to visualise and understand EAF files.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
